<div class="submenu">
    <ul>
        <li *ngFor="let link of links"><a routerLink="{{ link.url }}">{{ link.text }}</a></li>
    </ul>
</div>

